<template>
  <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'">
    <WithdrawTabTable></WithdrawTabTable>
  </v-card>
</template>
<script>
import WithdrawTabTable from "./WithdrawTabTable.vue";

export default {
  components: {
    WithdrawTabTable,
  },
};
</script>
